<template>
	<v-dialog v-model="dialog" persistent max-width="400" scrollable content-class="rounded-xl">
		<v-card>
			<v-card-title class="justify-space-between">
				<div class="font-size-13 cl-agen-dark">Bonus Claim</div>
				<v-btn small text class="px-0 mr-n4" @click="modalHide">
					<v-icon color="red">mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text class="pt-2">
				<v-row>
					<v-col cols="12">
						<div class="font-size-10 cl-dark-green">Enter the bonus amount you want to claim.</div>
					</v-col>
					<v-col cols="12" class="pt-0">
						<v-currency-field placeholder="Nominal Klaim" color="amber" prepend-inner-icon="mdi-database" hide-details="auto" v-model="nominal"></v-currency-field>
						<div class="pt-3 font-size-10 cl-grey">Minimum bonus that can be claimed is RM 15,02</div>
					</v-col>
				</v-row>
			</v-card-text>
			<v-card-actions class="justify-center">
				<v-col cols="6" class="text-center">
					<v-btn color="amber accent-3" width="120" height="45" depressed class="white--text rounded-xl text-capitalize" :loading="btn_loading" :disabled="btn_disabled" @click="claim">Claim</v-btn>
				</v-col>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>

export default {
	data () {
		return {
			dialog: false,
			btn_disabled: true,
			btn_loading: false,
			nominal: null,
		}
	},
	watch:{
		nominal: function(val) {
			if (val >= 50000) {
				this.btn_disabled = false
			} else {
				this.btn_disabled = true
			}
		}
	},
	props: {
	},
	methods :{
		modalShow() {
			this.dialog = true
		},
		modalHide() {
			this.dialog = false
			this.btn_loading = false
			this.nominal = null
		},
		loadingButton() {
			this.btn_loading = true
		},
		normalButton() {
			this.btn_loading = false
		},
		async claim() {
			await this.$emit('action', this.nominal)
		},
	}
};
</script>